/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector } from 'react-redux';
// material
import { Page, Content } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import SectionLoader from "../../../../material/sectionloader/sectionloader";
// content
import CompanyInfo from "./companyinfo/companyinfo";
import AuthenticationConfig from "../../../profile/company/authentication/authentication"
// styles
import injectSheet from "react-jss";
import styles from './company_styles';
import ProfileConfig from 'pages/dashboard/settings/company/profile/profile';
import { PRODUCT_COMMENTING_V2 } from 'state/thunks/account';

/* ========== ~~~~~~~~~~ COMPANY PAGE ~~~~~~~~~~ ========== */
const CompanyPage = injectSheet(styles)((props) => {
  const updateStatus = useSelector((state) => state.account.companyInfoUpdateStatus)
  const {mocked} = useSelector(state => state.session);
  const { accountProducts: productAccess } = useSelector((state) => state.account);

  const hasCommentingV2Access = productAccess?.includes(PRODUCT_COMMENTING_V2);

  return (
    <Page>
      <Content>
        <PageHeader title={'Settings'} subtitle={'Company'} />
        <PageContent>
          {updateStatus === 'pending'
            ? <SectionLoader />
            : <CompanyInfo />}
          {mocked && <AuthenticationConfig/>}
          {hasCommentingV2Access && <ProfileConfig />}
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CompanyPage;